import * as THREE from 'three'
import { transformSVGPath2 } from 'bam-node-evp/src/3d/Utils/TransformSVG'
import StadiumPaths from 'bam-node-evp/src/3d/Utils/StadiumOutfields'

export function addAllStadiums(scene) {
    const stadiumIds = Object.keys(StadiumPaths)

    stadiumIds.forEach((id) => {
        addStadiumById(scene, id)
    })
}

export function removeFieldById(scene, id) {
    const object = scene.getObjectByName(`infield_${id}`)
    if (object) {
        scene.remove(object)
    }
}

export function removeAllStadiums(scene) {
    const stadiumIds = Object.keys(StadiumPaths)

    stadiumIds.forEach((id) => {
        removeStadiumById(scene, id)
        removeFieldById(scene, id)
        removeFenceById(scene, id)
    })
}

export function removeStadiumById(scene, id) {
    const object = scene.getObjectByName(`venue_${id}`)
    if (object) {
        scene.remove(object)
    }
}

export function removeFenceById(scene, id) {
    const object = scene.getObjectByName(`fence_${id}`)
    if (object) {
        scene.remove(object)
    }
}

export function addStadiumById(scene, id) {
    const { outfield, hasTransform } = StadiumPaths[id] || {}
    const fieldPath = transformSVGPath2(outfield, hasTransform)
    // let fieldPath = transformSVGPath(stadiums.getStadiums(id))
    // if (id === 3289) {
    //     fieldPath = TransformSVGPath2(stadiums.getStadiums(id), true)
    // }
    const extrudeSettings = {
        depth: 1,
        bevelEnabled: true,
        bevelSegments: 2,
        steps: 2,
        bevelSize: 1,
        bevelThickness: 1,
    }
    const geometry = new THREE.ExtrudeGeometry(fieldPath, extrudeSettings)
    const material = new THREE.MeshPhongMaterial({
        color: 0xbbe8e4,
        shininess: 0.25,
        //        specular: '#c2c2c2',
        wireframe: false,
        flatShading: false,
        wireframeLinewidth: 0.4,
        transparent: true,
        opacity: 1,
    })
    const mesh = new THREE.Mesh(geometry, material)
    mesh.name = `venue_${id}`
    scene.add(mesh)
    addInfield(scene, 3)
}

export function addInfield(scene, id) {
    removeFieldById(scene, id)
    const { infield, hasTransform } = StadiumPaths[id] || {}
    if (infield) {
        const fieldPath = transformSVGPath2(infield, hasTransform)
        const extrudeSettings = {
            depth: 2,
            bevelEnabled: true,
            bevelSegments: 2,
            steps: 2,
            bevelSize: 1,
            bevelThickness: 1,
        }
        const geometry = new THREE.ExtrudeGeometry(fieldPath, extrudeSettings)
        const material = new THREE.MeshBasicMaterial({
            color: 0xffffff,
            wireframe: false,
            flatShading: false,
            wireframeLinewidth: 0.4,
            transparent: true,
            opacity: 1,
            side: THREE.DoubleSide,
        })
        const mesh = new THREE.Mesh(geometry, material)
        mesh.name = `infield_${id}`
        scene.add(mesh)
    }
}
